<template>
	<div>
		Competition
		<div class="fake-select">
			<select v-model="selectedComp">
				<option
					v-for="(comp, index) in competitions"
					:value="comp.id"
					:key="comp.id">
					{{comp.name}}
				</option>
			</select>
			<div class="initial-option">
				{{compDisplay}}
			</div>
		</div>
		Season
		<div class="fake-select">
			<select name="" id="" v-model="selectedSeason">
				<option
					v-for="(season, index) in seasons"
					:value="season.id"
					:key="season.id">
					{{season.name}}
				</option>
			</select>
			<div class="initial-option">
				{{seasonDisplay}}
			</div>
		</div>
		Match
		<div class="fake-select">
			<select name="" id="" v-model="selectedMatch">
				<optGroup
					v-for="(round, index) in flattenedRounds"
					:label="(round.name) ? round.name : round.number"
					:key="round.number">
					
					<option
						v-for="match in round.matches"
						:value="match.id"
						:key="match.id">
							{{match.title}}
					</option>

				</optGroup>
			</select>
			<div class="initial-option">
				{{matchDisplay}}
			</div>
		</div>

		<input type="" name="" disabled :value="selectedMatch">
	</div>
</template>

<script>
	export default {
		name: 'match',
		data () {
			return {
				competitions: [],
				seasons: [],
				matches: [],
				selectedComp: null,
				selectedSeason: '',
				selectedMatch: '',
				compDisplay: 'Choose a competition',
				seasonDisplay: '',
				matchDisplay: '',
			}
		},
		methods: {
			getData: function(endpoint, callback) {
				let self = this;
				var xhr = new XMLHttpRequest();
				xhr.open('GET', endpoint, true);
				xhr.send(null);

				xhr.onreadystatechange = function () {
					var
					DONE = 4,
					OK = 200;
						
					if (xhr.readyState === DONE) {
						if (xhr.status === OK) {
							let jsonResponse = JSON.parse(xhr.responseText)
							callback(jsonResponse);
						} else {
							console.log('Error: ' + xhr.status)
						}
					}
				}
			}
		},
		watch: {
			selectedComp: function(val, oldval) {
                let self = this;

			    if (val != oldval) {
                    self.selectedSeason = '';
                    self.selectedMatch = '';
                    self.seasonDisplay = '';
                    self.matchDisplay = '';
				};

				this.getData('https://api.ffa.football/c'+this.selectedComp+'/seasons', function(callback) {
					self.seasons = callback;
				});

				function match(item) {
					return item.id == val;
				}

				self.compDisplay = self.competitions.find(match).name;
				self.seasonDisplay = 'Choose a season';
			},
			selectedSeason: function(val, oldval) {
				let self= this;

                if (val != oldval) {
                    self.selectedMatch = '';
                    self.matchDisplay = '';
                };

				this.getData('https://api.ffa.football/c'+self.selectedComp+'/s'+self.selectedSeason+'/fixture', function(callback){
					self.matches = callback;
				});

				function match(item) {
					return item.id == val;
				}

				self.seasonDisplay = self.seasons.find(match).name;
				self.teamDisplay = 'Choose a team';
			},
			selectedMatch: function(val) {
				let self = this;
                this.$emit('matchUpdated', self.selectedMatch);
                let selected = '';
                self.flattenedRounds.forEach(function (rounds) {
                    rounds.matches.forEach(function (match) {
                        if (match.id == val) {
                            selected = match.title;
                        };
                    });
                });
                self.matchDisplay = selected;
			}
		},
		mounted: function () {
			let self = this;
			this.getData('https://api.ffa.football/competitions', function(callback){
				self.competitions = callback;
			});
		},
		computed: {
			flattenedRounds: function() {
                let _rounds = this.matches.rounds;
                let compRounds = [];
				if (_rounds) {
                    _rounds.forEach(function (round) {
                        let roundNum = round.round_number;
                    	if ( typeof compRounds[roundNum] === 'undefined' ) {
                            compRounds[roundNum] = round.round;
                            compRounds[roundNum].matches = [];
						};
                        compRounds[roundNum].matches.push(round);
                    });
                };
                return compRounds.filter(function(){return true;});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.fake-select {
		height: 50px;
		position: relative;
		margin-bottom: 10px;
		margin-top: 3px;

		select {
			position: absolute;
			border: 0;
			left: 0;
			top: 0;
			height: 100%;
			width: 100%;
		}

		.initial-option {
			background-color: #fff;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
			pointer-events: none;
			border: 1px solid #dadada;
			line-height: 50px;
			color: #49D49D;
			font-size: 20px;
			padding: 0 20px;

			&:after {
				content: '';
				display: block;
				width: 0px;
				height: 8px;
				position: absolute;
				right: 20px;
				top: 50%;
				margin-top: -4px;
				border: 8px solid transparent;
				border-top-color: #49D49D;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Match.vue?26d9c377